import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['checkbox', 'checkboxAll'];

  connect() {
    if (!this.hasCheckboxAllTarget) return;

    this.refresh();
  }

  toggle(event) {
    event.preventDefault();

    this.enabledCheckboxes.forEach((target) => {
      target.checked = event.target.checked;
      target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    });
  }

  refresh() {
    this.checkboxAllTarget.checked = this.checked.length > 0;
    this.checkboxAllTarget.indeterminate = this.isIndeterminate;
    this.checkboxAllTarget.disabled = this.isAllDisabled;
  }

  uncheckAll() {
    this.enabledAndChecked.forEach((checkbox) => {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    });

    this.refresh();
  }

  // Private

  get checked() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked);
  }

  get enabledCheckboxes() {
    return this.checkboxTargets.filter((checkbox) => !checkbox.disabled);
  }

  get enabledAndChecked() {
    return this.enabledCheckboxes.filter((checkbox) => checkbox.checked);
  }

  get isIndeterminate() {
    return this.checked.length > 0 && this.checked.length < this.enabledCheckboxes.length;
  }

  get isAllDisabled() {
    return this.checkboxTargets.length === 0 || this.checkboxTargets.every((checkbox) => checkbox.disabled);
  }
}
